export default {
  'pages.register.title': '注册',
  'pages.register.brand': 'Liulian AI',
  'pages.register.subtitle': '创建账户，开启 AI 创作之旅',
  'pages.register.accountRegister.tab': '账号密码注册',
  'pages.register.emailRegister.tab': '邮箱验证码注册',
  'pages.register.username.placeholder': '用户名',
  'pages.register.username.required': '请输入用户名',
  'pages.register.username.length': '用户名长度为 4-15 位',
  'pages.register.password.placeholder': '密码',
  'pages.register.password.required': '请输入密码',
  'pages.register.password.length': '密码长度为 4-20 位',
  'pages.register.confirmPassword.placeholder': '确认密码',
  'pages.register.confirmPassword.required': '请再次输入密码',
  'pages.register.confirmPassword.mismatch': '两次输入的密码不一致',
  'pages.register.inviterId.placeholder': '邀请码（选填）',
  'pages.register.inviterId.invalid': '邀请码须为正整数',
  'pages.register.email.placeholder': '邮箱',
  'pages.register.email.required': '请输入邮箱',
  'pages.register.email.invalid': '邮箱格式不正确',
  'pages.register.captcha.placeholder': '验证码',
  'pages.register.captcha.required': '请输入验证码',
  'pages.register.captcha.get': '获取验证码',
  'pages.register.captcha.sent': '验证码已发送至邮箱',
  'pages.register.captcha.sendFailed': '验证码发送失败，请稍后重试',
  'pages.register.agreement': '我已阅读并同意服务条款',
  'pages.register.agreement.required': '请先同意服务条款',
  'pages.register.submit': '注册',
  'pages.register.success': '注册成功，请登录',
  'pages.register.failure': '注册失败，请重试',
  'pages.register.accountRegister.errorMessage': '注册失败，请检查账号信息',
  'pages.register.emailRegister.errorMessage': '注册失败，请检查邮箱或验证码',
  'pages.register.backHome': '返回首页',
  'pages.register.hasAccount': '已有账户？ {login}',
  'pages.register.loginNow': '立即登录',
};
